import { render, staticRenderFns } from "./lecture-purchase-dialog.vue?vue&type=template&id=acddd7d6"
import script from "./lecture-purchase-dialog.vue?vue&type=script&lang=js"
export * from "./lecture-purchase-dialog.vue?vue&type=script&lang=js"
import style0 from "./lecture-purchase-dialog.vue?vue&type=style&index=0&id=acddd7d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports